module.exports = __webpack_public_path__ + "static/media/new_bg.56d0b70c.png";